<div class="register-layout">
  <div class="row form-layout">
    <div class="col-md-10 form position-relative">
      <div>
        <div class="row">
          <div>
            <div class="form-label mt-3">
              <h2 class="dashboard-sub-heading">Assign Bank</h2>
            </div>

            <hr>

            <p class="form-label"><i class="bi bi-info-circle"></i> Select one or more banks and click
              button to assign
            </p>
            <div class="row mt-3 justify-content-center">
              <div class="col-md-5 text-start">
                <div class="panel m-height panel-default">
                  <div class="form-label">All Banks</div>
                  <div class="mt-2 mb-2">
                    <mdb-form-control>
                      <input #input (input)="searchUnselected(input?.value)" mdbInput
                             type="search" id="form1" class="form-control" />
                      <label mdbLabel class="form-label p-1" for="form1">Search</label>
                    </mdb-form-control>
                  </div>
                  <div class="panel-body" [ngClass]="Listloading ? 'blur-background' : ''">
                    <div *ngIf="Listloading" class="position-absolute top-50 start-50 translate-middle">
                      <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                    </div>
                    <ul id="unselectedList">
                      <li *ngFor="let item of unselectedBanks"
                          (click)="togglePendingSelection(item)" class="list-group-item"
                          [class.selected]="item.selected">
                        {{item.bankName}}
                    </ul>
                    <div *ngIf="unselectedBanks==undefined || unselectedBanks.length == 0"
                         class="mt-3">
                      <h4 class="dashboard-heading m-l-10"
                          style="text-align: center; color: rgb(175, 175, 175); margin: 3px; line-height: inherit;">
                        No banks available
                      </h4>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-1 mt-5" style="padding: 0px;">
                <div class="text-center">
                  <button [disabled]="unselectedBanks==undefined || unselectedBanks.length == 0"
                          type="button" class="btn btn-primary mt-1 mb-1 ml-1 mr-1"
                          title="Assign selected banks" (click)="addToSelectedBanks()">
                    <i class="custom-icon-button2"></i>
                  </button>
                  <button [disabled]="selectedBanks==undefined || selectedBanks.length == 0"
                          type="button" class="btn btn-warning  mt-1 mb-1 ml-1 mr-1"
                          title="Unassign selected banks" (click)="removeFromSelectedBanks()">
                    <i class="custom-icon-button1"></i>
                  </button>
                  <button [disabled]="unselectedBanks==undefined || unselectedBanks.length == 0"
                          type="button" class="btn btn-primary  mt-1 mb-1 ml-1 mr-1"
                          title="Assign all banks" (click)="addAllToSelectedBanks()">
                    <i class="custom-icon-button4"></i>
                  </button>
                  <button [disabled]="selectedBanks==undefined || selectedBanks.length == 0"
                          type="button" class="btn btn-warning  mt-1 mb-1 ml-1 mr-1"
                          title="Unassign all banks" (click)="addAllToUnselectedBanks()">
                    <i class="custom-icon-button3"></i>
                  </button>
                </div>
              </div>

              <div class="col-md-5 text-start">
                <div class="panel m-heightpanel-default">
                  <div class="form-label">Assigned Banks</div>
                  <div class="panel-body panel-body-selected"
                       [class.panel-body-error]="noBankAssigned">
                    <li *ngFor="let item of selectedBanks" (click)="togglePendingSelection( item )"
                        class="list-group-item" [class.selectedA]="item.selected">
                      <i class="fas fa-spinner mr-2" style="color: #ffb626;"></i>
                      {{item.bankName}}
                    <li *ngFor="let item of alreadyassignedBanks" class="list-group-item"
                        style="background-color: #f5f5f5;">
                      <i class="fas fa-check-circle mr-2" style="color: #54b4a8;"></i>
                      {{item.bankName}}
                    </li>
                    <div *ngIf="(alreadyassignedBanks==undefined || alreadyassignedBanks.length == 0) && (selectedBanks==undefined || selectedBanks.length == 0)"
                         class="mt-3">
                      <h4 class="dashboard-heading m-l-10"
                          style="text-align: center; color: rgb(175, 175, 175); margin: 3px; line-height: inherit;">
                        No banks assigned yet
                      </h4>
                    </div>
                  </div>
                  <div *ngIf="noBankAssigned">
                    <p class="panel-error-msg">Please assign at least one bank</p>
                  </div>
                </div>
              </div>

              <div class="d-flex" style="justify-content:flex-end;">
                <div class="">
                  <div class="p-2">
                    <button type="button" class="btn btn-primary mt-4" type="submit"
                            (click)="onClickAssignBanks()">
                      <div *ngIf="loading" class="spinner-border spinner-border-sm text-light"
                           role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p *ngIf="!loading">
                        Assign
                      </p>
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div *ngIf="loading" class="position-absolute top-50 start-50 translate-middle">
        <div *ngIf="loading" class="position-absolute z-i-1000 top-50 start-50 translate-middle vstack">
          <div class="spinner-border text-primary spiner-w-h" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-add-bank-account></app-add-bank-account>
